import React, { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Alert, Button, InputField, LoadingSpinner, ModalDialog, SelectField } from 'vetrf-ui';
import { SingleFileUploadEdit } from 'components/SingleFileUploadEdit/SingleFileUploadEdit';
import { KILOBYTE_MAX_LENGTH } from 'utils/consts/consts';
import { BaseDictCodes, LanguageDictOption } from 'api/dict/params';
import { dictApi } from 'api/dict';
import { getMimeTypeValidation } from 'api/file/utils';
import { defaultAcceptedFileTypes } from 'api/file/params';

type UploadFormProps = {
  onClose: () => void;
  title: string;
  saving: boolean;
};

export const UploadForm = ({ onClose, title, saving }: UploadFormProps) => {
  const { getValues, setValue } = useFormContext();
  const [languageOptions, setLanguageOptions] = useState<LanguageDictOption[]>([]);
  const acceptedFileTypes = useMemo(() => getMimeTypeValidation(defaultAcceptedFileTypes), []);

  const getLanguageOptions = async () => {
    const res = await dictApi.baseDict<LanguageDictOption>(BaseDictCodes.LANGUAGE);
    setLanguageOptions(res);
    if (!getValues('language')?.id) {
      setValue(
        'language',
        res.find((l) => l.codeAlfa3 === 'rus')
      );
    }
  };

  useEffect(() => {
    getLanguageOptions();
  }, []);

  return (
    <ModalDialog
      header={title}
      onClose={onClose}
      footer={
        <>
          <Button
            disabled={saving}
            type="submit"
            color="success"
            iconColor="white"
            iconSize={100}
            size="sm"
            text="Сохранить"
          />
          <Button
            color="grey"
            iconColor="white"
            iconSize={100}
            onClick={onClose}
            size="sm"
            text="Отменить"
          />
        </>
      }
    >
      <div>
        <InputField
          labelText="Наименование"
          name="name"
          maxLength={KILOBYTE_MAX_LENGTH}
          required="Необходимо заполнить поле"
        />
        <SelectField
          labelText="Язык"
          name="language"
          labelKey="name"
          valueKey="id"
          options={languageOptions}
          required="Необходимо заполнить поле"
        />
        <SingleFileUploadEdit
          name="selectedFile"
          labelText="Файл"
          required
          uploadedFileName="file"
          acceptedFileTypes={acceptedFileTypes}
        />

        {saving && (
          <Alert messageType="info">
            <LoadingSpinner color="blue" icon="spinner" spin="spin" text="Сохранение" />
          </Alert>
        )}
      </div>
    </ModalDialog>
  );
};
